module.exports = __webpack_public_path__ + "img/banco-do-brasil-official.9cc60828.svg";